// The web root only provides context and a View. Import that implementation
// directly; actual gesture screens load the gesture library when opened.
export const GestureRoot: typeof import("react-native-gesture-handler").GestureHandlerRootView =
  require("react-native-gesture-handler/lib/module/components/GestureHandlerRootView").default;
